import { render, staticRenderFns } from "./Move.template.vue?vue&type=template&id=6551b6aa&scoped=true&"
var script = {}
import style0 from "./Move.template.vue?vue&type=style&index=0&id=6551b6aa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6551b6aa",
  null
  
)

export default component.exports